<template>
  <div class="l-tooltip z-index-[1000]" @mouseover="open = true" @mouseout="open = false" :style="`--main-bg-color: ${color};`">
    <slot></slot>
    <div class="tooltip-label" v-if="(open || active) && label" :style="size ? `min-width: ${size};` : ''">{{ label }}</div>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue'

defineProps({
  label: String,
  color: {
    type: String,
    default: '#0d6efd',
  },
  active: {
    type: Boolean,
    default: false,
  },
  size: String,
})

const open = ref(false)
</script>

<style>
.l-tooltip {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  position: relative;
}

.tooltip-label {
  display: block;
  position: absolute;
  font-size: 12px;
  text-align: left;

  max-width: 240px;
  bottom: calc(100% + 15px);
  /* left: -12px; */
  right: -12px;
  border-radius: 5px;
  padding: 5px 8px;
  z-index: 10;
  color: white;
  background: var(--main-bg-color);
  overflow-wrap: break-word;
}

.tooltip-label:before {
  content: '';
  position: absolute;
  top: calc(100%);
  right: 10px;
  border-style: solid;
  border-width: 10px;
  border-color: var(--main-bg-color) transparent transparent transparent;
}
</style>
